<template>
  <div class="home" @click="$router.push(`/start`)">
    <v-row class="">
      <v-col class="col-md-7 col-12 d-none d-sm-none d-md-flex">
        <div class="d-flex justify-center align-end fill-height">
          <img class="home_logo" :src="require('@/assets/logo.svg')" />
          <v-carousel
            cycle
            hide-delimiters
            hide-delimiter-background
            :show-arrows="false">
            <v-carousel-item
              v-for="(item,i) in left"
              :key="i"
              :src="item.src"
              reverse-transition="fade-transition"
              transition="fade-transition"
            ><h2>{{ item.txt }}</h2></v-carousel-item>
          </v-carousel>
        </div>
      </v-col>
      <v-col class="col-md-5 col-12 d-flex justify-center align-center">
        <div class="d-flex justify-center align-center fill-height">
          <img class="home_logo d-lg-none d-md-none d-xl-flex" :src="require('@/assets/logo.svg')" />
          <v-fade-transition>
          <div class="home_img" v-show="currentIndex == 0">
            <div class="d-flex justify-center align-center fill-height">
              <img :src="require('@/assets/home5_' + curr +'.png')">
            </div>
          </div>
          </v-fade-transition>
          <v-carousel
            cycle
            height="532"
            hide-delimiters
            hide-delimiter-background
             v-model="currentIndex"
            :show-arrows="false">
            <v-carousel-item
              v-for="(item,i) in right"
              :key="i"
              :src="item.src"
              reverse-transition="fade-transition"
              transition="fade-transition"
            ><h2 class="d-flex d-md-none d-lg-none d-xl-none">{{ item.txt }}</h2></v-carousel-item>
          </v-carousel>
        </div>
        <div class="home_btn" align="center">
          <v-btn
            block
            class="btn_start"
            color="#D56A51"
            depressed
            v-text="$t('home.start_free_trial')"
            :to="`/start`"
          ></v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Compounds from "@/components/Compounds";

export default {
  name: "Home",
  mixins: [Compounds],
  data(){
    return{
      currentIndex: 0,
      left: [
        {
          src: require('@/assets/home3.png'),
          txt: 'VIRTUALMAN for ADMET/PK'
        },
        {
          src: require('@/assets/home1.png'),
          txt: 'ADDD(AI-Driven Drug Development) platform'
        }
      ],
      right: [
        {
          src: '',
          txt: 'VIRTUALMAN for ADMET/PK'
        },
        {
          src: require('@/assets/home2.png'),
          txt: 'ADDD(AI-Driven Drug Development) platform'
        }
      ]
    }
  },
  computed: {
    curr(){
      return Math.floor(Math.random() * 3 + 1);
    }
  }
};
</script>
